import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpClientLinkSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpClientLinkSearchParams';

  // No constructor override on purpose. SearchParamsBase's only constructor argument is `isNew`,
  // and the framework relies on it: GeneralSearchPanelFigma builds the url-push diff baseline with
  // `new sp(true)` to get pristine defaults with no url loading. A `constructor(clientId)` here
  // swallowed that argument — the baseline both loaded the url and got ClientId = true — so the
  // diff was computed against the wrong object. TpClientLinkAdmin assigns ClientId after
  // constructing instead, and re-forces it on every search.
  initialize() {
    this.ClientId = '';
    this.Id = '';
    this.CaspianClientId = '';
    this.CaspianClientName = '';
    this.ThirdPartyClientId = '';
    this.ThirdPartyClientName = '';
    this.ThirdPartySource = '';
    // Empty on purpose (unlike TpLocation, which defaults to linked-only): finding the third-party
    // clients not yet linked to a Bravo client is a main reason to open this page, so the list must
    // not hide them by default.
    this.LinkedToCaspianClient = '';
  }

  // Same order as the grid columns, so a filter is found where its column sits: this record's own
  // id, then the Bravo side of the link, then the third-party side, then source.
  static fieldsInSearchBox = [
    {
      fieldName: 'Id',
      label: 'TP Client Link Id',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'CaspianClientId',
      label: 'Bravo Client Id',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'CaspianClientName',
      label: 'Bravo Client Name',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartyClientId',
      label: 'Third-Party Client Id',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    // Every name/id label is qualified with the system it belongs to: the list shows the Bravo
    // client alongside the third-party one, so an unqualified "Name" or "Id" is ambiguous.
    {
      fieldName: 'ThirdPartyClientName',
      label: 'Third-Party Client Name',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartySource',
      label: 'Source',
      className: 'col-4',
      type: InputTypesEnum.ThirdPartySourceSelect,
    },
    {
      fieldName: 'LinkedToCaspianClient',
      label: 'Linked to Bravo Client',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      // Standalone only. Embedded in a client every row is linked to that client by definition, so
      // the filter is meaningless there and "No" would always return nothing. `hide` rather than
      // `showCondition`: the latter renders a PlaceHolder to keep the layout stable while fields
      // toggle, but this one never toggles, so it would leave a permanent empty slot.
      hide: (searchItem) => !!searchItem.ClientId,
    },
  ];
}
